// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const glassworks = defineModel({
  id: "glassworks",
  batchId: "future",
  name: "Glassworks",
  tags: ["building","glassworks","low-poly","age-of-mcp","future"],
  summary: "Melts sand into glass for windows, bottles and lenses.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.3, 0.62), color: "#8a4a38", position: [0, 0.29, -0.12] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [-0.42, 0.3, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.6, 4), color: "#6b4a26", position: [0.42, 0.3, 0.42] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.6, 0.62), color: "#8a4a38", position: [0, 0.44, -0.12] },
      { geometry: new THREE.BoxGeometry(0.18, 1.06, 0.18), color: "#8a4a38", position: [0.2, 0.67, -0.3] },
      { geometry: new THREE.BoxGeometry(0.22, 0.06, 0.22), color: "#4a2418", position: [0.2, 1.23, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [-0.42, 0.525, 0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.05, 4), color: "#6b4a26", position: [0.42, 0.525, 0.42] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.62, 0.62), color: "#8a4a38", position: [0, 0.45, -0.12] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.453431), color: "#6e3a28", position: [0, 0.91, 0.05], rotation: [0.722979, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.92, 0.06, 0.453431), color: "#6e3a28", position: [0, 0.91, -0.29], rotation: [-0.722979, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.96, 0.07, 0.07), color: "#4a2418", position: [0, 1.06, -0.12] },
      { geometry: new THREE.BoxGeometry(0.18, 1.06, 0.18), color: "#8a4a38", position: [0.2, 0.67, -0.3] },
      { geometry: new THREE.BoxGeometry(0.22, 0.06, 0.22), color: "#4a2418", position: [0.2, 1.23, -0.3] },
      { geometry: new THREE.BoxGeometry(0.4, 0.34, 0.3), color: "#9a5040", position: [-0.12, 0.31, 0.06] },
      { geometry: new THREE.BoxGeometry(0.22, 0.2, 0.1), color: "#ff7a2e", position: [-0.12, 0.29, 0.22] },
      { geometry: new THREE.BoxGeometry(0.3, 0.04, 0.14), color: "#3a3a3a", position: [0.18, 0.34, 0.26] },
      { geometry: new THREE.BoxGeometry(0.03, 0.2, 0.03), color: "#3a3a3a", position: [0.06, 0.24, 0.26] },
      { geometry: new THREE.BoxGeometry(0.03, 0.2, 0.03), color: "#3a3a3a", position: [0.3, 0.24, 0.26] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.4, 6), color: "#3a3a3a", position: [0.16, 0.38, 0.26], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.SphereGeometry(0.04, 7, 5), color: "#ff7a2e", position: [-0.06, 0.38, 0.26] },
      { geometry: new THREE.ConeGeometry(0.16, 0.14, 9), color: "#d8caa0", position: [-0.3, 0.21, 0.28] },
    ] },
  ],
  animations: [],
});
